export class SharedVehicleGroupAdminModel {
  public shareVehicleGroupAdminHashID: string;
  public sharedVehicleGroupHashId: string;
  public groupName: string;
  public userName: string;
  public firstName: string;
  public lastName: string;
  public instanceId: string;
  public personHashID: string;
  public isChecked: boolean;
  public isActive: boolean;
  public isUserGroupAdmin:boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroupadmin/models/sharedvehiclegroupadmin.model.ts